import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ife-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
  @Input() showNext = true;
  @Input() disabledNext = false;
  @Input() showPrevious = true;
  @Input() showSetDefault = false;
  @Input() showSkip = false;
  @Input() skipText: string;
  @Input() showContinueLater = false;

  @Output() nextStep: EventEmitter<any> = new EventEmitter();
  @Output() previousStep: EventEmitter<any> = new EventEmitter();
  @Output() defaultValue: EventEmitter<any> = new EventEmitter();
  @Output() skipStep: EventEmitter<any> = new EventEmitter();
  @Output() continueLaterStep: EventEmitter<any> = new EventEmitter();

  public next() {
    this.nextStep.emit();
  }

  public previous() {
    this.previousStep.emit();
  }

  public setDefault() {
    this.defaultValue.emit();
  }

  public skip() {
    this.skipStep.emit();
  }

  public continueLater() {
    this.continueLaterStep.emit();
  }
}
